import React, { Component } from 'react'
import AsideNavbar from '../components/navbars/AsideNavbar'
import Navbars from '../components/navbars/Navbars'
import BookmarkHeaderSection from '../components/bookmarks/bookmark_videos/BookmarkHeaderSection'
import BookmarkShortnotesMaterialsSection from '../components/bookmarks/bookmark_shortnotes_materials/BookmarkShortnotesMaterialsSection';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { withRouter } from 'react-router';
const FETCH_GLOBALS = gql` 
query($student_user_exam_id: Int!) {
    studentGlobals(student_user_exam_id: $student_user_exam_id){
        tags{
            id
            tag
            type
            count
        }
        contentTypes{
            id
            customcontent
        }
    }
}

`;

const UPDATE_STUDENT_ANALYTICS = gql`
mutation(
  $params:AnalyticsStudents1  
  ) {
      studentAnalytics(
      params: $params
   )
}
`;



// Inline shimmer skeleton (filter bar + stacked cards) shown while loading.
const BookmarkShortnotesMaterialsShimmer = () => (
    <div className="py-4">
        <div className="d-flex flex-wrap mb-4">
            {[0, 1, 2, 3].map(i => <div key={i} className="rz-shimmer mr-2 mb-2" style={{ width: '90px', height: '34px', borderRadius: '20px' }} />)}
        </div>
        {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="rz-skel-card border-0 mb-3">
                <div className="rz-shimmer rz-skel-line" style={{ width: '35%' }} />
                <div className="rz-shimmer rz-skel-line sm" style={{ width: '95%' }} />
                <div className="rz-shimmer rz-skel-line sm" style={{ width: '85%' }} />
                <div className="d-flex mt-3">
                    <div className="rz-shimmer rz-skel-btn mr-2" style={{ width: '100px' }} />
                    <div className="rz-shimmer rz-skel-btn" style={{ width: '100px' }} />
                </div>
            </div>
        ))}
    </div>
);

class BookmarkShortnotesMaterials extends Component {
    constructor(props) {
        super(props)
        // Router state is missing when the page is opened directly (new tab, refresh in some
        // browsers, shared link), so fall back to "all tags / all subjects".
        const navState = props.history.location.state || {};

        let tagid = "";
        if (navState.tagid != undefined && navState.tagid != "") {
            tagid = navState.tagid;
        }

        let subjectid = 0;
        if (navState.subjectid != undefined && navState.subjectid != "") {
            subjectid = navState.subjectid;
        }
        let defaultActiveKey = "first";
        if (navState.defaultActiveKey != undefined) {
            defaultActiveKey = navState.defaultActiveKey;
        }

        this.state = {
            toggled: "wrapper sidebar-enable",
            subjectId: subjectid,
            chapterId: 0,
            tags: tagid,
            currentStep: 1,
            defaultActiveKey: defaultActiveKey,
            submitError:""

        }

    }
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
         if (toggled === "wrapper") {
             this.setState({toggled:"wrapper sidebar-enable"});
             Cookies.set("toggle", "wrapper sidebar-enable");
         } else {
             this.setState({toggled:"wrapper"});
             Cookies.set("toggle", "wrapper");
         }
     };
    componentDidMount() {
        this.addStudentAnalytics();

        window.addEventListener('contextmenu',
            event => event.preventDefault());


        // window.addEventListener("mousedown", e => {
        //     e.preventDefault();
        //     e.returnValue = "false";

        // });
        window.addEventListener("selectstart", e => {
            e.preventDefault();
            e.returnValue = "false";

        });
    }
    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 85,
            source: 2

        }
        //console.log("addStudentObj", addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    componentWillUnmount() {

        window.removeEventListener('contextmenu', () => { });
        // window.removeEventListener("mousedown", () => { });
        window.removeEventListener("selectstart", () => { });

    }
    handleSelectInputChange = (name, value) => {
        console.log("handleSelectInputChange", "name", name, "value", value);
        this.setState({ [name]: value });
    }
    TaghandleSelectInputChange = e => {
        //console.log("TaghandleSelectInputChange", e);
        let tagsValues = Array();
        if (e != null) {
            for (let i = 0; i < e.length; i++) {
                const tagval = e[i];
                tagsValues.push(tagval.value);
            }
            this.setState({
                tags: tagsValues.toString()
            });
        }
        //console.log("tagsValues", tagsValues);

    }

    render() {
        console.log("BookmarkShortnotesMaterials", this.state);

        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        

        const studentGlobals = this.props.studentGlobals;
        const loading3 = studentGlobals.loading;
        const error3 = studentGlobals.error;

       

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }
        let globalsubjects = "";
        if (JSON.parse(localStorage.getItem("globalsubjects")) != "") {
            globalsubjects = JSON.parse(localStorage.getItem("globalsubjects"));
        }
        else {
            this.props.history.push("/student/login");
        }
        //console.log("getStudentTags", getStudentTags.getStudentTags);

        return (
            <div className={Cookies.get("toggle")}>
                <div className="header-area">
                    <Navbars onClick={() => this.menuToggler()} />
                </div>
                <div className="main-wrapper">
                    
                    <AsideNavbar onClick={() => this.menuToggler()}/>
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        {(loading3 == true) && (<BookmarkShortnotesMaterialsShimmer />)}
                        {
                            !loading3 && (
                                <React.Fragment>
                                    <BookmarkHeaderSection
                                        type="bookmark"
                                        ctype="short"
                                        studentGlobals={studentGlobals.studentGlobals}
                                        getSubjects={globalsubjects}
                                        phandleSelectInputChange={this.handleSelectInputChange}
                                        pTaghandleSelectInputChange={this.TaghandleSelectInputChange}
                                        stateData={this.state}
                                        
                                    />
                                    <BookmarkShortnotesMaterialsSection
                                    
                                        getData={this.props.history.location.state || {}}
                                        studentGlobals={studentGlobals.studentGlobals}
                                        getSubjects={globalsubjects}
                                        stateData={this.state}
                                        parentremovebookhandleFormSubmit={this.removebookhandleFormSubmit}
                                    />
                                </React.Fragment>
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }
}
export default
    withRouter( compose(

        graphql(FETCH_GLOBALS,
            {
                options: props => ({
                    variables: {
                        student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                    },
                    fetchPolicy: "cache-and-network"
                }), name: "studentGlobals"
            }),
            graphql(UPDATE_STUDENT_ANALYTICS, {
                name: "submitpt"
            }),
        

    )(BookmarkShortnotesMaterials));
